import { create } from "zustand";

export const userStore = create((set) => ({
  attinfo: false,
  identified: false,
  user: {},
  typyCars: [],
  behalf: {},
  behalfAll: [],
  isUserTester: false,
  isUserLocalAdmin: false,
  isUserCorporateCard: false,
  isUserAccountsPayable: false,
  isUserSupervisor: false,
  isUserAdditionalAcceptor: false,
  isUserAdministration: false,
  isUserFromNorthAmerica: false,
  isUserCostGroup: false,
  isUserLocalHR: false,
  isUserPL: false,
  isMobile: false,
  setIsMobile: (val) => set((state) => ({ isMobile: val })),

  setAttinfo: (val) => set((state) => ({ attinfo: val })),
  setIdentified: (val) => set((state) => ({ identified: val })),
  setUser: (val) => set((state) => ({ user: val })),
  updateUser: (value) =>
    set((state) => ({ user: { ...state.user, ...value } })),
  addUserVehicle: (newVehicle) =>
    set((state) => ({
      user: {
        ...state.user,
        vehicles: { data: [...state.user.vehicles.data, newVehicle] },
      },
    })),
  updateUserVehicle: (newVehicle) =>
    set((state) => ({
      user: {
        ...state.user,
        vehicles: {
          data: [
            ...state.user.vehicles.data.map((vehicle) => {
              if (vehicle.id === newVehicle.id) {
                return newVehicle;
              }
              return vehicle;
            }),
          ],
        },
      },
    })),
  deleteUserVehicle: (id) =>
    set((state) => ({
      user: {
        ...state.user,
        vehicles: {
          data: [...state.user.vehicles.data].filter(
            (vehicle) => vehicle.id !== id
          ),
        },
      },
    })),
  setTypyCars: (val) => set((state) => ({ typyCars: val })),
  setBehalf: (val) => set((state) => ({ behalf: val })),
  setBehalfAll: (val) => set((state) => ({ behalfAll: val })),
  setIsUserTester: (val) => set((state) => ({ isUserTester: val })),
  setIsUserLocalAdmin: (val) => set((state) => ({ isUserLocalAdmin: val })),
  setIsUserCorporateCard: (val) =>
    set((state) => ({ isUserCorporateCard: val })),
  setIsUserAP: (val) => set((state) => ({ isUserAccountsPayable: val })),
  setIsUserSupervisor: (val) => set((state) => ({ isUserSupervisor: val })),
  setIsUserAdditionalAcceptor: (val) =>
    set((state) => ({ isUserAdditionalAcceptor: val })),
  setIsUseAdministration: (isUserAdministration) =>
    set({ isUserAdministration }),
  setIsUserNA: (val) => set((state) => ({ isUserFromNorthAmerica: val })),
  setIsUserLocalHR: (val) => set((state) => ({ isUserLocalHR: val })),
  setIsUserPL: (val) => set((state) => ({ isUserPL: val })),
  setIsUserCostGroup: (val) => set((state) => ({ isUserCostGroup: val })),
}));
